var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('h1',{staticStyle:{"font-size":"26px"}},[_vm._v(_vm._s(_vm.page.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }